import { jsx as _jsx } from "react/jsx-runtime";
import { ContainerLayoutType } from '@/types';
import { LayoutContainerColumnsBlock } from './ContainerColumns';
import { LayoutContainerGridBlock } from './ContainerGrid';
export const LayoutContainerBlock = ({ block, renderBlock }) => {
    switch (block.layout_config.type) {
        case ContainerLayoutType.COLUMNS: {
            return (_jsx(LayoutContainerColumnsBlock, { block: block, renderBlock: renderBlock }));
        }
        case ContainerLayoutType.GRID: {
            return _jsx(LayoutContainerGridBlock, { block: block, renderBlock: renderBlock });
        }
        default: {
            throw new Error('Unsupported layout Block type');
        }
    }
};
